import { createContext, useContext } from 'react';
import type { Theme } from '@fluentui/react-components';

export const MokoThemeContext = createContext<Theme | null>(null);

export const useActiveTheme = (): Theme => {
  const theme = useContext(MokoThemeContext);
  if (!theme) {
    throw new Error('useActiveTheme must be used within a MokoThemeProvider');
  }
  return theme;
};
